import { render, staticRenderFns } from "./Filtrele.vue?vue&type=template&id=bb2e9b8e&scoped=true"
import script from "./Filtrele.vue?vue&type=script&lang=js"
export * from "./Filtrele.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2e9b8e",
  null
  
)

export default component.exports